import { createOutlineIcon } from "../createIcon";

export const FilterOutlineIcon = createOutlineIcon(
  <>
    <path d="M6.46158 11.9996H17.5385M4.00003 6.9996H20M10.1539 16.9996H13.8462" />
  </>,
  "FilterOutlineIcon"
);
